<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Donation Amount">
            <div style="position: relative">
              <AmountSelector />
              <ErrorLabel field="amount" style="text-align: right" />
            </div>
          </FormSection>
          <FormSection v-if="form.amount">
            <TransactionFee />
          </FormSection>
          <FormSection title="Donation Frequency">
            <div class="frequency">
              <PaymentOptions addMonthly addSplit/>
            </div>
          </FormSection>  
          <FormSection title="Donation Designation">
            <FormRow class="designation" inline>
              <FormSelect field="applications.0.subCampaign">
                  <option selected="selected" value="Regional">Regional</option>

                  <option selected="selected" value="Kansas City">Kansas City</option>
                  <option selected="selected" value="Minneapolis">Minneapolis</option>
                  <option selected="selected" value="Memphis">Memphis</option>
                  <option selected="selected" value="Chicago">Chicago</option>
                  <option selected="selected" value="North Shore">North Shore</option>
                  <option selected="selected" value="JFE">JFE</option>
                  <option selected="selected" value="St. Louis">St. Louis</option>
                  <option selected="selected" value="4G">4G</option>
              </FormSelect>
              <ErrorLabel field="applications.0.campaign" style="text-align: right" />
            </FormRow>
          </FormSection>     
          <FormSection title="Notes">
            <FormRow>
              <FormInput type="textarea" class="width-half" field="custom.Notes" />
            </FormRow>
          </FormSection>
          <FormSection>
            <InHonorOf />
          </FormSection>
          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/"/>
                    </FormRow>                   
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donate Now" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  setup() {
    const { setValue, form, getValue } = usePaymentForm();

    
      const params = queryParams()

  
      if (params.designation) {
      //@ts-ignore
      switch (params.designation.toLowerCase()) {
        case "minneapolis":
          setValue("applications.0.subCampaign", "Minneapolis");
          break;
        case "regional":
          setValue("applications.0.subCampaign", "Regional");
          break;
        case "kansas":
          setValue("applications.0.subCampaign", "Kansas City");
          break;
        case "memphis":
          setValue("applications.0.subCampaign", "Memphis");
          break;
        case "chicago":
          setValue("applications.0.subCampaign", "Chicago");
          break;
        case "north shore":
          setValue("applications.0.subCampaign", "North Shore");
          break;
      }
    }

    
    return {
      form,
      getValue,
      setValue,
    };
  },
});
</script>
<style scoped lang="scss">
::v-deep h2 {
  color: #1aa8d3;
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 25px;
}

::v-deep .form-container.ou-donation-form {
  max-width: 100%;
}
::v-deep
  .styled-radio-container--ou-donation.styled-radio-container
  input[type="radio"]:checked
  + label {
  background: #1aa8d3;
}
::v-deep hr {
  background: none;
  box-shadow: none;
  height: 0;
  border: none;
  margin-bottom: 20px;
  border-bottom: 1px solid #efefef;
}

::v-deep .styled-radio--ou-donation.styled-radio .radio-part {
  @media (min-width: 720px) {
    min-width: 33.3%;
    flex: 1;
    max-width: 33.3%;
  }
}

.designation {
  display: flex;
  width: 100%;
  position: relative;
  ::v-deep select {
    flex: 1;
    min-width: 50%;
    max-width: 50%;
    margin-right: 1%;
  }
  ::v-deep select:last-child {
    margin-right: 0;
  }
}

::v-deep .styled-radio-container--ou-donation.styled-radio-container .radio-part{
  @media (min-width: 720px) {
  min-width: 25%;
    max-width: 25%;
  }
}
</style>
